import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { catchError, forkJoin, map, of } from 'rxjs';

// Range Slider
// import { Options } from '@angular-slider/ngx-slider';

// // Swiper Slider


import { popular, latestCar } from './home1.model';
import { rentalReasonsCards } from './data';
import { carroceriasVisiveis } from '../../../core/constants/carrocerias';
import { CatalogoCarroceriasService } from '../../../core/services/catalogo-carrocerias.service';
import { NoticiasService } from '../../../core/services/noticias.service';
import { NoticiaApi } from '../../../core/services/catalog-api.model';
import { BlogCardView, mapNoticiaToCard, noticiaDetailLink } from '../../../core/utils/blog-noticia.util';
import { ConfiguracaoService } from '../../../core/services/configuracao.service';
import { HomeCtaSlideApi, PaginaBeneficioCardApi, PaginaBeneficiosPublic } from '../../../core/services/catalog-api.model';
import { HomeCtaService } from '../../../core/services/home-cta.service';
import { PaginaBeneficiosService } from '../../../core/services/pagina-beneficios.service';
import { resolveMediaUrl } from '../../../core/utils/media-url.util';
import { CatalogoVendaService } from '../../../core/services/catalogo-venda.service';
import { apenasPublicacoesVenda, mapAluguelToCard, mapVendaToCard, CatalogCard } from '../../../core/services/catalog-mappers';
import { CatalogoAluguelService } from '../../../core/services/catalogo-aluguel.service';
import { AuthService } from '../../../core/services/auth.service';
import { environment } from '../../../../environments/environment';
import { MetaPixelService } from '../../../core/services/meta-pixel.service';
import { GoogleTagService } from '../../../core/services/google-tag.service';
import { TranslocoService } from '@jsverse/transloco';
import { LocaleService } from '../../../core/services/locale.service';

import { TipoLocacao, locacaoUsaPrecoMensal, rotaDetalheLocacao } from '../../../core/constants/tipo-locacao';
import { itemDeCard, linhaDeTipoLocacao } from '../../../core/analytics-item';

interface BeneficioAlertaView {
  visivel: boolean;
  texto: string;
  botao_texto: string;
  botao_link: string;
}

const BENEFICIO_CARDS_FALLBACK: PaginaBeneficioCardApi[] = [
  {
    id: 1,
    titulo: 'Deixe a burocracia com a gente',
    texto: 'A Velz resolve tudo para você: IPVA, DPVAT, licenciamento e emplacamento. Cuidamos de cada detalhe do processo com agilidade e segurança, para que você não perca tempo com filas, prazos ou complicações.',
    imagem_path: 'assets/img/car-finder/icons/burocracia.png',
    ordem: 1,
  },
  {
    id: 2,
    titulo: 'Manutenções',
    texto: 'Conte com opções de manutenções preventivas e corretivas para manter seu veículo sempre em perfeito estado. A Velz oferece praticidade e confiança em cada serviço, garantindo mais segurança, desempenho e tranquilidade para o seu dia a dia.',
    imagem_path: 'assets/img/car-finder/icons/manutencao.png',
    ordem: 2,
  },
  {
    id: 3,
    titulo: 'Suporte completo 24h',
    texto: 'Você nunca fica na mão. Conte com assistência sempre perto de você, onde estiver. E, se precisar, tenha à disposição carro reserva por até 15 dias, garantindo sua mobilidade e tranquilidade em qualquer situação.',
    imagem_path: 'assets/img/car-finder/icons/24horas.png',
    ordem: 3,
  },
  {
    id: 4,
    titulo: 'Proteção completa para o veículo',
    texto: 'Tenha mais segurança e tranquilidade com cobertura contra roubo, furto, incêndio e colisão. A Velz oferece soluções pensadas para proteger você e seu patrimônio em qualquer situação.',
    imagem_path: 'assets/img/car-finder/icons/protecao.png',
    ordem: 4,
  },
  {
    id: 5,
    titulo: 'Gestão com relatórios inteligentes',
    texto: 'Tenha acesso a relatórios completos e estratégicos para acompanhar e otimizar sua operação. A Velz facilita a análise de dados, ajudando você a tomar decisões mais rápidas e eficientes no dia a dia.',
    imagem_path: 'assets/img/car-finder/icons/inteligencia.png',
    ordem: 5,
  },
  {
    id: 6,
    titulo: 'Compromisso com a sustentabilidade',
    texto: 'Torne sua frota mais sustentável com soluções que reduzem impactos ambientais e promovem eficiência no uso de recursos. A Velz ajuda você a alinhar desempenho com responsabilidade ambiental no dia a dia.',
    imagem_path: 'assets/img/car-finder/icons/sustentabilidade.png',
    ordem: 6,
  },
];

const HOME_CTA_FALLBACK: HomeCtaSlideApi[] = [
  {
    id: 1,
    titulo: 'Mercado automotivo',
    subtitulo: 'Escolha o melhor para seu carro!',
    botao_texto: 'Ir para a loja',
    botao_link: '/catalog/grid',
    estilo: 'produtos',
    ordem: 1,
    itens: [
      { id: 1, titulo: 'Capas de banco', imagem_path: 'assets/img/car-finder/categories/01.png', link: null, ordem: 1 },
      { id: 2, titulo: 'Pneus', imagem_path: 'assets/img/car-finder/categories/02.png', link: null, ordem: 2 },
      { id: 3, titulo: 'Rodas', imagem_path: 'assets/img/car-finder/categories/03.png', link: null, ordem: 3 },
      { id: 4, titulo: 'Cadeirinhas infantis', imagem_path: 'assets/img/car-finder/categories/04.png', link: null, ordem: 4 },
    ],
  },
  {
    id: 2,
    titulo: 'Venda de carro em 24 horas',
    subtitulo: 'Calculate your car\'s value, then choose how you want to sell.',
    botao_texto: 'Vender meu carro',
    botao_link: '/vendor/sell-car',
    estilo: 'icones',
    ordem: 2,
    itens: [
      { id: 5, titulo: 'Compradores verificados', imagem_path: 'assets/img/car-finder/icons/buyers.svg', link: null, ordem: 1 },
      { id: 6, titulo: 'Ferramentas inteligentes', imagem_path: 'assets/img/car-finder/icons/tools.svg', link: null, ordem: 2 },
      { id: 7, titulo: 'A oferta que você merece', imagem_path: 'assets/img/car-finder/icons/handshake.svg', link: null, ordem: 3 },
    ],
  },
];

interface EasyValidationResponse {
  ok: boolean;
  message: string | null;
}

@Component({
    selector: 'app-index',
    templateUrl: './home1.component.html',
    styleUrls: ['./home1.component.scss'],
    standalone: false
})

/**
 * Index Component
 */
export class Home1Component implements OnInit {

  popularData: popular[] = [];
  beneficioCards: PaginaBeneficioCardApi[] = [];
  beneficioAlerta: BeneficioAlertaView | null = null;
  beneficioSecaoTitulo = '';
  latestCarData: latestCar[] = [];
  apiCards: CatalogCard[] = [];
  /** Home: carrossel “categorias” = veículos para aluguel (API). */
  homeAluguelCards: CatalogCard[] = [];
  homeAluguelLoading = false;
  /** Ofertas em destaque (API: destaque=1) — ex.: /seminovos */
  featuredOfferCards: CatalogCard[] = [];
  featuredLoading = true;
  newsData: BlogCardView[] = [];
  showReservationFrame = true;
  /** Por enquanto o mesmo iframe do site velzrentacar.com.br. */
  useEasyReservationEmulator = false;
  easyReservationAction = 'https://reserva.easycarros.com/grupo.asp';
  private readonly reservationWindowName = 'velzReserva';
  reservationSubmitted = false;
  reservationLocations = [
    { value: '2', label: 'VelzLoja/Aeroport' },
  ];
  reservationHours = Array.from({ length: 24 }, (_, hour) => ({
    value: String(hour),
    label: `${String(hour).padStart(2, '0')}:00`,
  }));
  reservationForm = {
    pickupLocation: '2',
    returnLocation: '2',
    pickupDateIso: '',
    returnDateIso: '',
    pickupHour: '12',
    returnHour: '12',
  };
  reservationValidationMessage: string | null = null;
  reservationMessageKey: string | null = null;
  reservationChecking = false;
  minReservationDateIso = '';
  showVehicleSearch = false;
  /** Barra de busca simplificada (sem localização / tabs) para listagem de tercerização. */
  showTercerizacaoVehicleSearch = false;
  showFeaturedOffers = true;
  recentCarouselTitle = 'Carros mais recentes';
  showRecentCarouselImageBadges = true;
  simpleRecentCarouselCards = false;
  /** Home: três cards estáticos em grelha em vez de carrossel + API */
  fixedRecentReasonsGrid = false;
  showTercerizacaoGrowingSection = false;
  homeTipoLocacao: TipoLocacao = 'diario';
  ctaVisivel = false;
  ctaReady = false;
  ctaSlides: HomeCtaSlideApi[] = [];

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly http: HttpClient,
    private catalogoVenda: CatalogoVendaService,
    private readonly catalogoAluguel: CatalogoAluguelService,
    private readonly noticias: NoticiasService,
    public readonly configuracao: ConfiguracaoService,
    public readonly auth: AuthService,
    private readonly paginaBeneficios: PaginaBeneficiosService,
    private readonly homeCta: HomeCtaService,
    private readonly carrocerias: CatalogoCarroceriasService,
    private readonly metaPixel: MetaPixelService,
    private readonly googleTag: GoogleTagService,
    private readonly transloco: TranslocoService,
    public readonly locale: LocaleService,
  ) { }

  irParaLogin(): void {
    void this.router.navigate(this.locale.localizeLink(['/auth/signin']), { queryParams: { returnUrl: this.router.url } });
  }

  rentalEmptyType(): string {
    const key = this.homeTipoLocacao === 'assinatura'
      ? 'home.typeSubscription'
      : this.homeTipoLocacao === 'tercerizacao'
        ? 'home.typeOutsource'
        : 'home.typeDaily';
    return this.transloco.translate(key);
  }

  linkVenda(id: number): (string | number)[] {
    return this.locale.localizeLink(['/catalog/single', 'venda', id]);
  }

  linkRecente(data: latestCar): string | (string | number)[] {
    if (data.id != null) {
      return this.locale.localizeLink(['/catalog/single', data.modo || 'venda', data.id]);
    }
    return this.locale.localizePath('/catalog/single');
  }

  ngOnInit(): void {
    this.initReservationForm();
    this.loadHomeCta();
    this.route.fragment.subscribe((fragment) => {
      if (fragment === 'reservar') {
        setTimeout(() => this.scrollToReservation());
      }
    });

    const applyRouteData = (data: Record<string, unknown>) => {
      this.showReservationFrame = data['heroAction'] === 'reservation';
      this.showVehicleSearch = data['heroAction'] === 'search';
      this.showTercerizacaoVehicleSearch = data['showTercerizacaoVehicleSearch'] === true;
      this.showFeaturedOffers = data['showFeaturedOffers'] !== false;
      const recentTitle = data['recentCarouselTitle'];
      this.recentCarouselTitle = recentTitle === 'Razões para alugar na Velz'
        ? 'home.razoesAlugar'
        : 'home.carrosRecentes';
      this.showRecentCarouselImageBadges = data['showRecentCarouselImageBadges'] !== false;
      this.simpleRecentCarouselCards = data['simpleRecentCarouselCards'] === true;
      this.fixedRecentReasonsGrid = data['fixedRecentReasonsGrid'] === true;
      this.showTercerizacaoGrowingSection = data['showTercerizacaoGrowingSection'] === true;
      const tipoLocacao = data['tipoLocacao'];
      this.homeTipoLocacao =
        tipoLocacao === 'assinatura' || tipoLocacao === 'tercerizacao' || tipoLocacao === 'diario'
          ? tipoLocacao
          : this.showTercerizacaoGrowingSection
            ? 'tercerizacao'
            : 'diario';
      this.loadBeneficios();
      this.atualizarCategoriasPopulares();
    };
    this.route.data.subscribe(d => {
      applyRouteData(d as Record<string, unknown>);
      this.loadRecentCarouselData();
      this.loadHomeAluguelCategories();
    });

    // Chat Data Get Function
    this._fetchData();

    if (document.documentElement.scrollTop > 40) {
      document.querySelector('.navbar')?.classList.add('navbar-stuck');
    }

  }

  cardImagem(path: string): string {
    return resolveMediaUrl(path);
  }

  beneficioLinkInterno(link: string | null | undefined): boolean {
    const value = String(link ?? '').trim();
    return value.startsWith('/') && !value.startsWith('//');
  }

  ctaHref(link: string | null | undefined): string {
    const value = (link ?? '').trim();
    if (value.startsWith('/') && !value.startsWith('//')) {
      return this.locale.localizePath(value);
    }
    return value;
  }

  private ctaFallback(): HomeCtaSlideApi[] {
    const t = (key: string) => this.transloco.translate(key);
    const itemKey: Record<number, string> = {
      1: 'home.ctaCovers',
      2: 'home.ctaTires',
      3: 'home.ctaWheels',
      4: 'home.ctaSeats',
      5: 'home.ctaBuyers',
      6: 'home.ctaTools',
      7: 'home.ctaOffer',
    };
    return HOME_CTA_FALLBACK.map((slide) => ({
      ...slide,
      titulo: t(slide.id === 1 ? 'home.ctaMarket' : 'home.ctaSell'),
      subtitulo: t(slide.id === 1 ? 'home.ctaMarketSub' : 'home.ctaSellSub'),
      botao_texto: t(slide.id === 1 ? 'home.ctaShop' : 'home.ctaSellBtn'),
      itens: slide.itens.map((item) => ({
        ...item,
        titulo: t(itemKey[item.id] ?? 'home.ctaMarket'),
      })),
    }));
  }

  private loadHomeCta(): void {
    this.homeCta.publico().subscribe({
      next: (res) => {
        this.applyCta(!!res.visivel, res.slides ?? []);
      },
      error: () => {
        this.applyCta(true, this.ctaFallback());
      },
    });
  }

  private applyCta(visivel: boolean, slides: HomeCtaSlideApi[]): void {
    this.ctaVisivel = visivel;
    this.ctaSlides = slides;
    this.slideConfig = {
      ...this.slideConfig,
      infinite: slides.length > 1,
    };
    this.ctaReady = true;
  }

  private loadBeneficios(): void {
    if (!this.showTercerizacaoGrowingSection || (this.homeTipoLocacao !== 'tercerizacao' && this.homeTipoLocacao !== 'assinatura')) {
      this.beneficioCards = [];
      this.beneficioAlerta = null;
      this.beneficioSecaoTitulo = '';
      return;
    }

    const segmento = this.homeTipoLocacao;
    this.applyBeneficioFallback(segmento);
    this.paginaBeneficios.publico(segmento).subscribe({
      next: (res) => {
        if (this.homeTipoLocacao !== segmento) {
          return;
        }
        this.applyBeneficioResponse(res, segmento);
      },
      error: () => {
        if (this.homeTipoLocacao === segmento) {
          this.applyBeneficioFallback(segmento);
        }
      },
    });
  }

  private applyBeneficioResponse(res: PaginaBeneficiosPublic, segmento: 'tercerizacao' | 'assinatura'): void {
    if (!res.alerta && (!res.cards || res.cards.length === 0)) {
      this.applyBeneficioFallback(segmento);
      return;
    }
    this.beneficioSecaoTitulo = res.titulo_secao?.trim() || '';
    this.beneficioCards = res.cards ?? [];
    this.beneficioAlerta = res.alerta
      ? {
          visivel: !!res.alerta.visivel,
          texto: res.alerta.texto,
          botao_texto: res.alerta.botao_texto,
          botao_link: res.alerta.botao_link,
        }
      : null;
  }

  private applyBeneficioFallback(segmento: 'tercerizacao' | 'assinatura'): void {
    this.beneficioSecaoTitulo = '';
    this.beneficioCards = BENEFICIO_CARDS_FALLBACK.map((card, index) => ({
      ...card,
      titulo: this.transloco.translate(`home.benefit${index + 1}Title`),
      texto: this.transloco.translate(`home.benefit${index + 1}Body`),
    }));
    this.beneficioAlerta = {
      visivel: true,
      texto: this.transloco.translate(segmento === 'assinatura' ? 'home.alertSubscription' : 'home.alertOutsource'),
      botao_texto: this.transloco.translate('home.contactNow'),
      botao_link: '/pages/contacts',
    };
  }

  prepareReservationSubmit(event: SubmitEvent): void {
    event.preventDefault();

    this.reservationValidationMessage = null;
    this.reservationMessageKey = this.getReservationValidationMessage();
    if (this.reservationMessageKey) {
      this.reservationSubmitted = false;
      return;
    }

    const form = event.target as HTMLFormElement | null;
    if (!form || this.reservationChecking) {
      return;
    }

    const reservationWindow = window.open('', this.reservationWindowName);
    this.reservationChecking = true;
    this.validateEasyReservation().subscribe((message) => {
      this.reservationChecking = false;
      this.reservationMessageKey = null;
      this.reservationValidationMessage = message;
      this.reservationSubmitted = !message;
      if (message) {
        reservationWindow?.close();
        return;
      }

      this.metaPixel.trackCustom('Botao-Reservas');
      this.googleTag.reservar();

      if (reservationWindow && !reservationWindow.closed) {
        this.postReservationForm(reservationWindow, form);
        return;
      }

      form.target = '_self';
      form.submit();
    });
  }

  private postReservationForm(targetWindow: Window, form: HTMLFormElement): void {
    const doc = targetWindow.document;
    doc.open();
    doc.write('<!doctype html><title>Reserva Velz</title><body></body>');
    doc.close();

    const popupForm = doc.createElement('form');
    popupForm.method = 'post';
    popupForm.action = form.action;
    new FormData(form).forEach((value, name) => {
      const input = doc.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      popupForm.appendChild(input);
    });
    doc.body.appendChild(popupForm);
    popupForm.submit();
  }

  get pickupDateBr(): string {
    return this.isoToBrDate(this.reservationForm.pickupDateIso);
  }

  get returnDateBr(): string {
    return this.isoToBrDate(this.reservationForm.returnDateIso);
  }

  get minReturnDateIso(): string {
    const pickup = this.reservationDateTime(this.reservationForm.pickupDateIso, this.reservationForm.pickupHour);
    return this.dateToIso(pickup ? this.addHours(pickup, 1) : this.minAllowedPickupDateTime());
  }

  onPickupChanged(): void {
    this.reservationValidationMessage = null;
    this.reservationMessageKey = null;
    const pickup = this.coercePickupMinimum();
    this.setReturnDateTime(this.addHours(pickup, 24));
  }

  onReturnChanged(): void {
    this.reservationValidationMessage = null;
    this.reservationMessageKey = null;
    this.coerceReturnMinimum();
  }

  private scrollToReservation(): void {
    document.getElementById('reservar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  private initReservationForm(): void {
    const now = new Date();
    const pickup = new Date(now);
    pickup.setDate(now.getDate() + 1);
    pickup.setHours(12, 0, 0, 0);
    const returnDate = this.addHours(pickup, 24);

    this.minReservationDateIso = this.dateToIso(this.minAllowedPickupDateTime());
    this.setPickupDateTime(pickup);
    this.setReturnDateTime(returnDate);
  }

  private dateToIso(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private isoToBrDate(value: string): string {
    const [year, month, day] = value.split('-');
    return year && month && day ? `${day}/${month}/${year}` : '';
  }

  private getReservationValidationMessage(): string | null {
    const form = this.reservationForm;
    if (!form.pickupLocation || !form.returnLocation || !form.pickupDateIso || !form.returnDateIso || !form.pickupHour || !form.returnHour) {
      return 'home.fillReservation';
    }

    const pickup = this.reservationDateTime(form.pickupDateIso, form.pickupHour);
    const returnDate = this.reservationDateTime(form.returnDateIso, form.returnHour);
    if (!pickup || !returnDate) {
      return 'home.checkDates';
    }
    if (pickup < this.minAllowedPickupDateTime()) {
      return 'home.pickupLead';
    }
    if (returnDate < this.addHours(pickup, 1)) {
      return 'home.returnLead';
    }

    return null;
  }

  private reservationDateTime(dateIso: string, hour: string): Date | null {
    if (!dateIso || hour === '') {
      return null;
    }

    const date = new Date(`${dateIso}T${String(hour).padStart(2, '0')}:00:00`);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  private minAllowedPickupDateTime(): Date {
    return this.ceilToHour(this.addHours(new Date(), 1));
  }

  private ceilToHour(date: Date): Date {
    const rounded = new Date(date);
    if (rounded.getMinutes() > 0 || rounded.getSeconds() > 0 || rounded.getMilliseconds() > 0) {
      rounded.setHours(rounded.getHours() + 1);
    }
    rounded.setMinutes(0, 0, 0);
    return rounded;
  }

  private addHours(date: Date, hours: number): Date {
    const result = new Date(date);
    result.setHours(result.getHours() + hours);
    return result;
  }

  private coercePickupMinimum(): Date {
    const current = this.reservationDateTime(this.reservationForm.pickupDateIso, this.reservationForm.pickupHour);
    const minimum = this.minAllowedPickupDateTime();
    const pickup = current && current >= minimum ? current : minimum;
    this.setPickupDateTime(pickup);
    return pickup;
  }

  private coerceReturnMinimum(): Date {
    const pickup = this.coercePickupMinimum();
    const minimum = this.addHours(pickup, 1);
    const current = this.reservationDateTime(this.reservationForm.returnDateIso, this.reservationForm.returnHour);
    const returnDate = current && current >= minimum ? current : minimum;
    this.setReturnDateTime(returnDate);
    return returnDate;
  }

  private setPickupDateTime(date: Date): void {
    this.reservationForm.pickupDateIso = this.dateToIso(date);
    this.reservationForm.pickupHour = String(date.getHours());
  }

  private setReturnDateTime(date: Date): void {
    this.reservationForm.returnDateIso = this.dateToIso(date);
    this.reservationForm.returnHour = String(date.getHours());
  }

  private validateEasyReservation() {
    const form = this.reservationForm;
    const horarioEndpoint = `${environment.apiBaseUrl}/easycarros/validar-horario`;
    const disponibilidadeEndpoint = `${environment.apiBaseUrl}/easycarros/validar-disponibilidade`;
    const requests = [
      this.http.post<EasyValidationResponse>(horarioEndpoint, {
        tipo: 1,
        empresa: Number(form.pickupLocation),
        data: this.pickupDateBr,
        hora: `${form.pickupHour.padStart(2, '0')}:00`,
      }),
      this.http.post<EasyValidationResponse>(horarioEndpoint, {
        tipo: 2,
        empresa: Number(form.returnLocation),
        data: this.returnDateBr,
        hora: `${form.returnHour.padStart(2, '0')}:00`,
        etapa_grupo: true,
      }),
      this.http.post<EasyValidationResponse>(disponibilidadeEndpoint, {
        empresa: Number(form.pickupLocation),
        data_locacao: this.pickupDateBr,
        hora_locacao: `${form.pickupHour.padStart(2, '0')}:00`,
        data_retorno: this.returnDateBr,
        hora_retorno: `${form.returnHour.padStart(2, '0')}:00`,
      }),
    ];

    return forkJoin(requests).pipe(
      map((results) => results.find((result) => !result.ok)?.message ?? null),
      catchError(() => of('Não foi possível validar a reserva. Tente novamente.')),
    );
  }

  /** Home (reserva): substitui ícones de categorias por cards de aluguel da API. */
  private loadHomeAluguelCategories(): void {
    if (!this.showReservationFrame) {
      this.homeAluguelCards = [];
      this.homeAluguelLoading = false;
      return;
    }
    this.homeAluguelLoading = true;
    this.catalogoAluguel.listar({ per_page: 12, page: 1, tipo_locacao: this.homeTipoLocacao }).subscribe({
      next: (res) => {
        this.homeAluguelCards = (res.data ?? []).map(mapAluguelToCard);
        const linha = linhaDeTipoLocacao(this.homeTipoLocacao);
        this.googleTag.verLista(linha, this.homeAluguelCards.map((card) => itemDeCard(card, linha)));
        this.homeAluguelLoading = false;
      },
      error: () => {
        this.homeAluguelCards = [];
        this.homeAluguelLoading = false;
      },
    });
  }

  precoMensalCard(): boolean {
    return locacaoUsaPrecoMensal(this.homeTipoLocacao);
  }

  rotaDetalheAluguel(card: CatalogCard): (string | number)[] {
    return this.locale.localizeLink(rotaDetalheLocacao(this.homeTipoLocacao, card.id));
  }

  selecionarAluguel(card: CatalogCard): void {
    const linha = linhaDeTipoLocacao(this.homeTipoLocacao);
    this.googleTag.selecionarItem(linha, itemDeCard(card, linha));
  }

  selecionarSeminovo(card: CatalogCard): void {
    this.googleTag.selecionarItem('Seminovos', itemDeCard(card, 'Seminovos'));
  }

  selecionarDestaque(card: CatalogCard): void {
    this.googleTag.selecionarItem('Destaques', itemDeCard(card, 'Seminovos'));
  }

  selecionarRecente(id: number | null | undefined): void {
    const card = this.apiCards.find((item) => item.id === id);
    if (card) {
      this.selecionarSeminovo(card);
    }
  }

  /** Carrossel “recentes” da home ou listagem seminovos — API só fora da grelha fixa */
  private loadRecentCarouselData(): void {
    if (this.fixedRecentReasonsGrid) {
      this.latestCarData = rentalReasonsCards.map((c) => ({ ...c }));
      return;
    }
    this.catalogoVenda.listar({ per_page: 8, sort: 'recent' }).subscribe({
      next: (res) => {
        this.apiCards = apenasPublicacoesVenda(res.data).map(mapVendaToCard);
        this.googleTag.verLista('Seminovos', this.apiCards.map((card) => itemDeCard(card, 'Seminovos')));
        this.latestCarData = this.apiCards.map((c) => ({
          id: c.id,
          modo: c.modo,
          verified_btn: c.verified_btn,
          btn: c.btn,
          btn_color: c.btn_color,
          image: c.image[0]?.img ?? 'assets/img/car-finder/catalog/09.jpg',
          year: c.year,
          title: c.title,
          price: c.modo === 'venda' ? `R$ ${c.price}` : `R$ ${c.price}/dia`,
          precoNumero: c.precoNumero,
          country: c.country,
          avg: c.avg,
          eng: c.eng,
          fuel: c.fuel,
        }));
      },
      error: () => {
        this.latestCarData = [];
      },
    });
  }

  private atualizarCategoriasPopulares(): void {
    const aplicar = (presentes: string[]) => {
      this.popularData = carroceriasVisiveis(presentes).map((c) => ({
        slug: c.slug,
        image: c.image,
        title: c.label,
      }));
    };
    aplicar([]);
    if (this.showReservationFrame) {
      return;
    }
    this.carrocerias.listar('seminovos').subscribe({
      next: (slugs) => aplicar(slugs),
      error: () => aplicar([]),
    });
  }

  // Chat Data Fetch
  private _fetchData() {
    this.noticias.list({ per_page: 6, sort: 'recent' }).subscribe({
      next: (p) => {
        const raw = p as { data?: NoticiaApi[] };
        const rows = Array.isArray(raw.data) ? raw.data : [];
        this.newsData = rows.map((n) => mapNoticiaToCard(n, {
          translate: (key, params) => this.transloco.translate(key, params),
          dateLocale: this.locale.current() === 'en' ? 'en' : 'pt-BR',
        }));
      },
      error: () => {
        this.newsData = [];
      },
    });
    this.featuredLoading = true;
    this.catalogoVenda.listar({ destaque: 1, per_page: 3 }).subscribe({
      next: (r) => {
        this.featuredOfferCards = apenasPublicacoesVenda(r.data).map(mapVendaToCard);
        this.googleTag.verLista('Destaques', this.featuredOfferCards.map((card) => itemDeCard(card, 'Seminovos')));
        this.featuredLoading = false;
      },
      error: () => {
        this.featuredOfferCards = [];
        this.featuredLoading = false;
      },
    });
  }

  /**
   * Swiper setting
   */
  noticiaLink(card: BlogCardView): string {
    return this.locale.localizePath(noticiaDetailLink(card));
  }

  Siderconfig = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true
  };

  slideConfig = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false
  };

  /**
   * Latest Carro Swiper setting
   */
  LatestCar = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      // Celular: um card por vez — com dois, título, preço e ícones ficavam espremidos.
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };



  /**
   * Swiper setting
   */
  // public CTA: SwiperOptions = {
  //   initialSlide: 0,
  //   slidesPerView: 1,
  //   navigation: true,
  //   loop: true
  // };

  /**
   * Notícias Swiper setting
   */
  news = {
    initialSlide: 0,
    slidesPerView: 1,
    spaceBetween: 25,
    pagination: true,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      }
    }
  };

}
